export class HierarchyQueryResult {
    public status: number;
    public value: any;
}
